//文件访问路由信息
import Vue from 'vue'
//获取设备信息
import MobileDetect from 'mobile-detect';

//加载配置文件
import store from './store/index'

//可更改的配置清单
const configJSON = {
    //微信JDK是否开启debug
    WX_DEBUG: false,
    //是否为测试模式
    DE_BUG: false,
    //主机网址
    HOST_URL: 'https://mm.51leyan.com/mobile/index.php?',
}
let API_URL = `${configJSON.HOST_URL}`;
//DE_BUG状态下
if (configJSON.DE_BUG) {
    API_URL = "https://mm.51leyan.com/mobile/index.php?";
    let wxId = '17702';
    let avatar = 'http://f.qingnong.org/mobile/public/img/user_default.png';
    let nickname = '小吴';
    let endtime = 1502245603;
    let token = '15073f24ad8a96596d6a80fdfed3f5dd';
    store.commit('updateWxId', wxId);
    store.commit('updateToken', token);
}
//获取用户设备信息
var md = new MobileDetect(window.navigator.userAgent);
let config = {
    MOBILE: md.mobile(),
    API_URL,
    HOST_URL: configJSON.HOST_URL,
    IMG_URL: `${configJSON.HOST_URL}/pc/`,
    IMG_API_URL: '',
    weRegisterUrl: `/WeRegister`,
    weIntegratedUrl: `/WeIntegrated`,
    weUserMainUrl: `/WeUserMain`,
}
//合并可配置 配置单与生成配置单
for (let x in configJSON) {
    config[x] = configJSON[x]
}
Vue.prototype.$config = config;
export { config }


// WEBPACK FOOTER //
// ./src/puConfig.js